import {
  cleanDirtyDraftV1,
  saveDraftV1,
  updateApprovedV1,
  updateDraftV1,
} from 'client/actions/DocumentsV1/draftV1/draftV1Actions'
import { validateDraftV1Thunk } from 'client/actions/DocumentsV1/draftV1/draftV1Thunks'
import { IThunkAction } from 'client/actions/index'
import { showGeneratingDocumentSpinner } from 'client/actions/ongoing'
import * as deliverynoteApi from 'client/api/deliverynote'
import * as api from 'client/api/draft'
import * as receiptApi from 'client/api/receipt'
import { DeliverynoteDraftInterface } from 'client/components/DocumentsV1/Deliverynote/DeliverynoteInterface'
import { ReceiptDraftInterface } from 'client/components/DocumentsV1/Receipt/ReceiptInterface'
import { DocumentTypes } from 'client/Interfaces/Draft/DraftInterface'
import { getDraftV1Selector } from 'client/reducers/draftV1Reducer'

type DraftInterface = ReceiptDraftInterface | DeliverynoteDraftInterface

export const saveDraftThunkV1 = (
  documentType: DocumentTypes,
): IThunkAction<null, string | DraftInterface, Promise<void>> => {
  return async (dispatch, getState) => {
    dispatch(validateDraftV1Thunk(documentType))
    const draft = getDraftV1Selector(getState())
    if (!draft.invalidFields) {
      dispatch(cleanDirtyDraftV1())
      const cleanedDraft = getDraftV1Selector(getState()) as DraftInterface
      if (!draft.id) {
        const savedDraft = await api.createDraftV1(documentType, cleanedDraft)
        dispatch(saveDraftV1(savedDraft))
      } else {
        const updatedDraft = await api.updateDraftV1(documentType, cleanedDraft)
        dispatch(updateDraftV1(updatedDraft))
      }
    }
  }
}

export const updateApprovedThunkV1 = (
  documentType: DocumentTypes,
  showSpinner = false,
): IThunkAction<null, string | DraftInterface, Promise<void>> => {
  return async (dispatch, getState) => {
    dispatch(validateDraftV1Thunk(documentType))
    const draft = getDraftV1Selector(getState())
    if (!draft.invalidFields && draft.id) {
      dispatch(cleanDirtyDraftV1())
      const cleanedDraft = getDraftV1Selector(getState()) as DraftInterface
      if (showSpinner) {
        dispatch(showGeneratingDocumentSpinner())
      }
      if (documentType === DocumentTypes.DELIVERYNOTE) {
        const deliverynote = await deliverynoteApi.saveDeliverynote(cleanedDraft as DeliverynoteDraftInterface)
        dispatch(updateApprovedV1(deliverynote))
      } else if (documentType === DocumentTypes.RECEIPT) {
        const receipt = await receiptApi.saveReceipt(cleanedDraft as ReceiptDraftInterface)
        dispatch(updateApprovedV1(receipt))
      }
    }
  }
}
